<template>
  <!-- 账单联系人列表 -->
  <div class="card-list page-wrapper">
    <div class="card-list-wrapper">
      <div class="card-list-title" @click="goInstitutions">
        <img src="../../assets/image/back.svg" alt="" />
        <span class="title-text">{{$t('design.creditCard.goInstitutions') || "返回机构设置"}}</span>
      </div>
    </div>

    <div class="card-list-main">
      <div class="card-list-box">
        <div class="list-info">
          <div class="list-text">
            <div class="title-text">{{$t('design.creditCard.billContactList') || "账单联系人列表"}}</div>
            <xl-button type="primary" @click="addContact">
              <XlPlus class="add-icon"></XlPlus>
              <span class="add-text">{{$t('design.creditCard.add') || "新增"}}</span>
            </xl-button>
          </div>
          <xl-scrollbar>
            <div class="list-box" v-if="billContactList?.length">
                <div class="card-box" v-for="(item, index) in billContactList" :key="item.id">
                  <div class="default-info">
                    <div class="set-text payment-text">{{$t('design.creditCard.contact') || '账单联系人'}}{{ index + 1 }}</div>
                    <div class="operate-box">
                      <xl-icon :size="24" color="#A5ACBE" @click="handleEdit(item)">
                        <img src="../../assets/image/edit.svg" alt=""/>
                      </xl-icon>
                      <xl-divider direction="vertical" />
                      <span>
                        <xl-icon :size="24" color="#A5ACBE" @click="handleDelete(item)">
                            <Delete1 />
                        </xl-icon>
                      </span>
                    </div>
                  </div>
                  <contactCard :contactInfo="item"></contactCard>
                </div> 
            </div>
            <!-- 暂无数据 -->
            <div class='no-data-box' v-else>
              <noData></noData>
            </div>
          </xl-scrollbar>
        </div>
      </div>
    </div>
  </div>
  <addContactDialog ref="addContactRef" @getBillContact="getBillContact"></addContactDialog>
</template>

<script setup>
import { ref } from "vue";
import { XlButton, XlSwitch, XlDivider, XlIcon, XlScrollbar, XlMessage } from "@shining3d/ui-components";
import { XlPlus, Delete1 } from "@shining3d/icons-vue";
import router from '@/router';
import addContactDialog from "./addContactDialog.vue";
import contactCard from "./contactCard.vue";
import noData from '../../components/no-data.vue'
import creditCardApi from "../../api/creditCard";
import { useStore } from "vuex";
import { useLang } from '@shining3d/common-module/utils/lang.js';
import _get from 'lodash/get';

const { $t } = useLang( '@shining3d/xl-design-order' );
const $store = useStore();
// 新增信用卡
const addContactRef = ref();
const addContact = () => {
  addContactRef.value.show('add');
};
// 编辑
const handleEdit = (row) => {
  addContactRef.value.show(row);
}
// 删除
const handleDelete = (row) => {
  creditCardApi.delBillContact({id: row?.id, businessID: institutionId, platform: window.app?.entryName || 'dental'}).then((res) => {
    if( res && res.status === 'success' ){
      XlMessage({
				type: 'success',
				message: $t('design.creditCard.deleteContactSuccess') || '删除账单联系人成功'
			});
      getBillContact();
    }
  });
}
// 账单联系人列表
const billContactList = ref([])
// 机构id
const institutionId = _get( $store, 'state.factorySelect.id', '' );
// 获取账单联系人列表
const getBillContact = () => {
  creditCardApi.getBillContact({businessID: institutionId, platform: window.app?.entryName || 'dental'}).then((res) => {
    if( res && res.status === 'success' ){
      billContactList.value = res.result || [];
    }
  });
};
getBillContact();
// 返回机构设置
const goInstitutions = () => {
    // router.push({path: '/u/creditCard'});
    router.go(-1);
}
</script>
<style lang="scss" scoped>
.card-list {
  font-family: "Alibaba PuHuiTi 2.0";
  .card-list-wrapper{
    padding: 16px 16px 0;
    background: #ffffff;
    display: flex;
    flex-direction: column;
  }
  .card-list-title {
    display: flex;
    margin-bottom: 16px;
    img {
      cursor: pointer;
    }
    .title-text {
      padding-left: 8px;
      font-size: 18px;
      font-weight: 700;
      line-height: 26px;
      color: #2c364e;
      cursor: pointer;
    }
  }
  .card-list-main {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    .card-list-box {
      padding: 16px;
      flex: 1;
      overflow-y: hidden;
      overflow-x: auto;
      .list-info {
        height: calc(100% - 48px);
        background: #ffffff;
        border-radius: 6px;
        flex-direction: column;
        padding: 24px;
        .list-text {
          display: flex;
          justify-content: space-between;
          margin-bottom: 24px;
          .title-text {
            font-size: 16px;
            font-weight: 700;
            line-height: 26px;
            color: #2c364e;
          }
          .add-text {
            padding-left: 4px;
          }
        }
        .card-box {
          width: 460px;
          height: 156px;
          display: inline-block;
          margin: 0 24px 24px 0;
          box-sizing: border-box;
          padding: 16px;
          border-radius: 10px;
          border: 1px solid #eff1f7;
          box-shadow: 0px 2px 10px 0px #111b330d;
          &:nth-child(2n){
            margin-right: 0 !important;
          }
          .default-info {
            display: flex;
            justify-content: space-between;
            margin-bottom: 16px;
            .set-text {
              font-size: 14px;
              font-weight: 500;
              line-height: 22px;
            }
            .payment-text {
              color: #2c364e;
            }
            .default-text {
              margin-right: 12px;
              color: #737e99;
            }
            .operate-box{
                display: flex;
                align-items: center;
                img{
                  cursor: pointer;
                }
                .xl-icon{
                  display: flex;
                }
            }
          }
        }
      }
    }
    .no-data-box{
      height: 100%;
    }
  }
  :deep(.el-scrollbar__wrap){
   height: calc(100% - 56px);
  }
  :deep(.el-scrollbar__view) {
      height: 100%;
  }
}
</style>
